/**
 * @file: PlatformAppId.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum PlatformAppId {
  Workbench = 'workbench.zhichetech.com',
  Boss = 'boss.zhichetech.com',
  StoreManager = 'store.zhichetech.com',
  OpenapiManager = 'openapi.zhichetech.com',
  ProductAgentManager = 'pa.zhichetech.com',
  AgentManager = 'agent.zhichetech.com',
}

export const PlatformAppIdValueSet = new Set([
  PlatformAppId.Workbench,
  PlatformAppId.Boss,
  PlatformAppId.StoreManager,
  PlatformAppId.OpenapiManager,
  PlatformAppId.ProductAgentManager,
  PlatformAppId.AgentManager,
]);
